
<div class="row" *ngIf="site">
    <div class="text-size col-3">
        <div class=" left-side-detail p-3  shadow-right rounded-1 min-vh-100">
        <div class="mb-4">
            <strong
                class="d-flex justify-content-center w-100 title-fs mb-3 text-slide-title">{{'SETTINGS.SITE_DETAILS' |
                translate}}</strong>
            <div class="d-flex align-items-center">
                <a (click)="backToEventList()" class="cursor d-flex align-items-center">
                    <mat-icon>keyboard_arrow_left</mat-icon>
                    {{ 'BUTTONS.BACK' | translate }}
                </a>
            </div>
        </div>
        <div>
            <div>
                <div class="row">
                    <div class="col-12 d-flex align-items-center">
                        <strong class="fs-6 fw-bold fs-5"> {{site.nom }}</strong>
                    </div>
                </div>
                <div class="row mt-2">
                    <div class="d-flex align-items-center">
                        <span class="status-icon" [ngClass]="{ 'active': site.isActif }">
                            <svg-icon [src]="site.isActif ? './icon/active.svg' : './icon/inactive.svg'"></svg-icon>
                            <span class="status-text">{{ site.isActif ? 'Active' : 'Inactive' }}</span>
                          </span>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 d-flex align-items-center">
                        <!-- <span class="number-symbol text-muted">N<sup
                                class="symbol">o</sup>{{controlPoint.numeroPoint}}</span> -->
                    </div>
                </div>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-6">
                <button type="button" class="secondary-button detail-edit-button" (click)="openPopupSite(siteId,site.regionId)">
                    <img src="icon/edit-pencil.svg" /> {{ 'BUTTONS.MODIFY' | translate }}
                </button>
            </div>
            <div class="col-6">
                <button type="button" class="tertiary-button" (click)="onDelete(siteId)">
                    <img src="icon/delete.svg" /> {{ 'BUTTONS.DELETE' | translate }}
                </button>
            </div>
        </div>
        <hr>
        <div class="row mt-2">
            <div class="col-6">
                <div class="text-muted">{{ 'SETTINGS.REGION' | translate }}</div>
                <div>{{site?.region.nom}}</div>
            </div>
            <div class="col-6">
                <div class="text-muted">{{ 'SETTINGS.COUNTRY' | translate }}</div>
                <div>{{paysName}}</div>
            </div>
        </div>
        <div class="row mt-2">
            <div class="col-6">
                <div class="text-muted">{{ 'SETTINGS.USERS' | translate }}</div>
                <div>{{site?.nbUtilisateurs}}</div>
            </div>
            <div class="col-6">
                <div class="text-muted">{{ 'SETTINGS.ADMINS_SITES' | translate }}</div>
                <!-- <div>{{site?.pays?.nom}}</div> -->
            </div>
        </div>
        <div class="row mt-2">
            <div class="col-6">
                <div class="text-muted">X</div>
                <div>{{site.coordX}}</div>
            </div>
            <div class="col-6">
                <div class="text-muted">Y</div>
                <div>{{site.coordY}}</div>
            </div>
        </div>
        <div class="row">
            <div class="col-6">
                <div>
                    <div class="text-muted">Z</div>
                    <!-- <div>{{site?.z}}</div> -->
                </div>
            </div>
            <div class="col-6">
                <div>
                    <div class="text-muted">{{ 'SETTINGS.BALST_WITHIN_LIMITS' | translate }}</div>
                    <!-- <div>{{site?.z}}</div> -->
                </div>
            </div>
        </div>
        <hr>
    </div>
    </div>
    <div class="col-9" *ngIf="siteId">
        <div style="display: flex; flex-direction: column;">
            <div style="display: flex;">
                <div class="p-3" (click)="changerTab(1)" style="cursor: pointer;">
                    <strong [ngClass]="tab == 1 ? 'highlighted-div': ''"><img src="./icon/users.svg" />
                        {{'SETTINGS.USERS' | translate}}
                    </strong>
                </div>
                <div class="p-3" (click)="changerTab(3)" style="cursor: pointer;">
                    <strong [ngClass]="tab == 3 ? 'highlighted-div': ''"><img src="./icon/notification.svg" />
                        {{'SETTINGS.ALARM_CONFIGURATION' | translate}}
                    </strong>
                </div>
                <div class="p-3" (click)="changerTab(2)" style="cursor: pointer;">
                    <strong [ngClass]="tab == 2 ? 'highlighted-div': ''"><img src="./icon/settings.svg" />
                        {{'DEVICE_CONFIG.DEVICE_CONFIGURATION' | translate}}
                    </strong>
                </div>
            </div>
            <div style="width: 100%;">
                <app-users *ngIf="tab == 1" [selectedUserId]="null" [selectedSiteId]="siteId" [selectedRegionId]="site.regionId"></app-users>
                <!-- <app-trigger-threshold *ngIf="tab == 2" [controlPointId]="null" [siteId]="siteId"></app-trigger-threshold>-->
                <app-alarm-configuration *ngIf="tab == 3"  [siteId]="siteId"></app-alarm-configuration> 
                <app-device-config *ngIf="tab == 2" [formGroup]="deviceConfigForm" [siteId]="siteId"></app-device-config>
            </div>
        </div>
</div>
